import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["useGap", "message", "options"];
import { useContext, createElement } from 'react';
// @ts-expect-error untyped JS module
import { classNameFix, getPassThroughProps, getValue } from './utils';
import { I18nHMRContext } from '../internal/i18n-internal';
const DEFAULT_OPTIONS = {};
function FormattedHTMLMessage(_ref) {
  let {
      useGap = false,
      message,
      options = DEFAULT_OPTIONS
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  useContext(I18nHMRContext);
  const props = classNameFix(getPassThroughProps(Object.assign({
    useGap,
    message,
    options
  }, rest)));

  // must use dangerouslySetInnerHTML prop to display embedded HTML
  return /*#__PURE__*/createElement('i18n-string', Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: getValue({
        useGap,
        message,
        options
      })
    }
  }));
}
FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.isI18nElement = true;
export default FormattedHTMLMessage;